import { createBrowserRouter } from "react-router-dom";
import MainLayout from "./lib/layouts/mainLayout";
import UnhandledException from "./pages/unhandled-exception";
import ProtectedLayout from "./lib/layouts/protectedLayout/protected-layout";
import AuthLayout from "./lib/layouts/authLayout/auth-layout";
import VirtualPosIPG from "./pages/protected/ipg/ipg";
import TransactionReport from "./pages/protected/transaction-report/transaction-report";
import NotFound from "./pages/not-found";
import Otp from "./pages/auth/otp/otp";

const router = createBrowserRouter(
  [
    {
      element: <MainLayout />,
      errorElement: <UnhandledException />,
      children: [
        {
          path: "/",
          element: <ProtectedLayout />,
          children: [
            {
              index: true,
              element: <VirtualPosIPG />,
            },
            {
              path: "/transaction-report",
              element: <TransactionReport />,
            },
          ],
        },
        {
          element: <AuthLayout />,
          children: [
            {
              path: "auth/otp",
              element: <Otp />,
            },
          ],
        },
        {
          path: "*",
          element: <NotFound />,
        },
      ],
    },
  ],
  {
    basename: "/v-pos",
  }
);

export default router;
